/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import defaultPrefs from './config/default-prefs';
import defaultConfig from './config/default-config';
import SvgCanvas from '../core/svgcanvas';
import { isIOSDevice, isSafari } from 'src/utils/safari';

// Note: The difference between Prefs and Config is that Prefs
//   can be changed in the UI and are stored in the browser,
//   while config cannot
let curPrefs = {};
let curConfig = { allowedOrigins: [] };
let editor;

export default function getEditor () {
  editor = Object.assign({
    init,
    loadSvgString,
    setCanvasSize,
    getOpacity,
    getStrokeWidth
  }, Backbone.Events);
  return editor;
}

function init () {
  // const host = location.hostname,
  //  onWeb = host && host.indexOf('.') >= 0;
  // Some FF versions throw security errors here when directly accessing
  try {
    if ('localStorage' in window) { // && onWeb removed so Webkit works locally
      editor.storage = localStorage;
    }
  } catch (err) {}

  const goodLangs = [];

  $('#lang_select option').each(function () {
    goodLangs.push(this.value);
  });

  setupCurConfig();
  setupCurPrefs();

  editor.canvas = new SvgCanvas(document.getElementById('svgcanvas'), curConfig);
  addCanvasExtensions();

  Object.assign(editor, {
    getMode,
    setMode,
    initScroll,
    getOffset,
    isClickInsideEditor,
    isElementClicked,
    getNextId,
    loadingElement,
    clearSelection,
    replaceElement,
    replaceBackground,
    addElement,
    getSvgString,
    getSelectedElems,
    openPrep,
    setFavColor,
    getFavColors,
    getEditorUsedColors,
    initEditor
  });

  editor.trigger('initialize');
}

function getMode () {
  return editor.canvas.getMode();
}

function setMode (mode) {
  editor.canvas.setMode(mode);
  editor.canvas.runExtensions('selectedChanged', {});
}

function setFlip (type) {
  const elems = editor.canvas.getSelectedElems();
  const svgroot = $('#svgroot').get(0);

  for (let i = 0; i < elems.length; i++) {
    const elem = elems[i];
    if (!elem) continue;

    const tlist = editor.canvas.getTransformList(elem);
    const translateOrigin = svgroot.createSVGTransform();
    const scale = svgroot.createSVGTransform();
    const translateBack = svgroot.createSVGTransform();
    const bb = elem.getBBox();

    const isSticker = (elem.tagName === 'g' && elem.getAttribute('class').indexOf('sticker') !== -1);
    switch (type) {
      case 'h':
        translateOrigin.setTranslate(isSticker
          ? -bb.x - bb.width / 2
          : -bb.x, -bb.y);
        scale.setScale(-1, 1);
        translateBack.setTranslate(bb.x + bb.width, bb.y);

        tlist.appendItem(translateBack);
        tlist.appendItem(scale);
        tlist.appendItem(translateOrigin);

        this.recalculateAllSelectedDimensions();

        break;

      case 'v':
        translateOrigin.setTranslate(-bb.x, isSticker
          ? -bb.y - bb.height / 2
          : -bb.y);
        scale.setScale(1, -1);
        translateBack.setTranslate(bb.x, bb.y + bb.height);

        tlist.appendItem(translateBack);
        tlist.appendItem(scale);
        tlist.appendItem(translateOrigin);

        this.recalculateAllSelectedDimensions();

        break;
    }
  }
}

function setupCurConfig () {
  curConfig = $.extend(true, {}, defaultConfig, curConfig); // Now safe to merge with priority for curConfig in the event any are already set

  // ...and remove any dupes
  $.each(['allowedOrigins'], function (i, cfg) {
    curConfig[cfg] = $.grep(curConfig[cfg], function (n, i) {
      return i === curConfig[cfg].indexOf(n);
    });
  });
  // Export updated config
  editor.curConfig = curConfig;
}

function addCanvasExtensions () {
  editor.canvas.setFlip = setFlip;

  for (const extension in INKIVE.EXTENSION) {
    editor.canvas.addExtension(extension, INKIVE.EXTENSION[extension]);
  }
}

function initScroll () {
  const $wrapper = $(curConfig.wrapper);

  $wrapper.antiscroll({
    autoHide: false,
    width: $wrapper.width(),
    height: $wrapper.height()
  });
}

function setupCurPrefs () {
  curPrefs = $.extend(true, {}, defaultPrefs, curPrefs);
  editor.curPrefs = curPrefs;
}

function loadSvgString (str, _callback, width, height) {
  _callback = _callback || $.noop;
  editor.canvas.clear();
  editor.canvas.setMode('select');

  width = parseInt(width || str.match(/<svg[^>]*width="(\d+(?:\.\d+)?)"[^>]*>/)[1]);
  height = parseInt(height || str.match(/<svg[^>]*height="(\d+(?:\.\d+)?)"[^>]*>/)[1]);

  setCanvasSize(width, height);
  if (editor.canvas.setSvgString(str)) {
    _callback(true);

    INKIVE.Helpers.displayImagesLoadingAnimation();
    const currentPageNumber = INKIVE.Tool._current_page_number;

    Promise.all([
      new Promise(resolve => INKIVE.EditorFacade.once('design-font.loaded', resolve)),
      new Promise(resolve => INKIVE.EditorFacade.once('custom-font.loaded', resolve)),
      new Promise(resolve => INKIVE.EditorFacade.once('page.changed', resolve))
    ]).then(async () => {
      if (currentPageNumber !== INKIVE.Tool._current_page_number) return;
      INKIVE.AdvancedOrderedListFactory.calculateOrderTrackingFromPreviousPages();

      await INKIVE.Helpers.delay(500);

      INKIVE.Text.Helpers.memoizedCalculateTextWidth?.cache?.clear();
      INKIVE.Helpers.converterCurrentPage();
      INKIVE.EditorFacade.trigger('page.converted', INKIVE.Tool._current_page_number);
    });
  } else {
    INKIVE.Modal.alertMessage('Error load SVG string', 'error');
    _callback(false);
  }
}

function setCanvasSize (width, height) {
  editor.canvas.contentW = width;
  editor.canvas.contentH = height;
}

function getOffset () {
  const canvasBackground = document.querySelector('#canvasBackground');

  if (!canvasBackground) return;
  const bb = canvasBackground.getBoundingClientRect();

  return {
    x: bb.left,
    y: bb.top,
    width: editor.canvas.contentW,
    height: editor.canvas.contentH
  };
}

function isClickInsideEditor (x, y) {
  const offset = this.getOffset();

  return x > offset.x &&
    y > offset.y &&
    x < offset.x + offset.width * editor.canvas.getZoom() &&
    y < offset.y + offset.height * editor.canvas.getZoom();
}

function isElementClicked (element, event) {
  const bbox = editor.canvas.getBBox(element);
  const offset = this.getOffset();

  const x = event.clientX - offset.x;
  const y = event.clientY - offset.y;

  const getBBoxValue = function (val) {
    return bbox[val] * editor.canvas.getZoom();
  };
  if (bbox) {
    return x > getBBoxValue('x') && y > getBBoxValue('y') && x < getBBoxValue('x') + getBBoxValue(
      'width') && y < getBBoxValue('y') + getBBoxValue('height');
  }
}

function getNextId () {
  return editor.canvas.getNextId();
}

function loadingElement (boolen) {
  editor.canvas.loadingElement(boolen);
}

function clearSelection () {
  editor.canvas.clearSelection();
}

function replaceElement (from, to, keepId, keepProportions, skipReselection) {
  editor.canvas.replaceElement(from, to, keepId, keepProportions, skipReselection);
  INKIVE.Tool.autoSave(to);
}

function replaceBackground (attr) {
  return editor.canvas.addElement('background', attr);
}

function addElement (type, attr, options) {
  const elem = editor.canvas.addElement(type, attr, options);
  elem && INKIVE.Tool.autoSave(elem);

  switch (type) {
    case 'background':
      break;
    default:
      editor.canvas.clearSelection();
      if (elem) editor.canvas.selectOnly([elem]);
      break;
  }

  return elem;
}

function getSvgString (node) {
  return editor.canvas.getSvgString(node);
}

function getSelectedElems () {
  editor.canvas.validateSelectedElems();

  return editor.canvas.getSelectedElems();
}

function openPrep (func) {
  $('#main_menu').hide();
  func(true);
}

function setFavColor (hex) {
  const colors = _.without(editor.getFavColors(), hex);
  colors.push(hex);
  localStorage.setItem('colors', JSON.stringify(colors));
}

function getFavColors () {
  if (!localStorage.getItem('colors')) {
    return [];
  }

  const colors = _.uniq(JSON.parse(localStorage.getItem('colors').toUpperCase()), false);
  return colors.slice(Math.max(colors.length - 10, 0));
}

function getEditorUsedColors () {
  const editorUsedColors = [];
  const hasColor = function (elem, attr) {
    const value = $(elem).attr(attr);
    return _.isString(value) && value !== 'null' && value !== 'none' && value.toUpperCase();
  };

  $('#svgcontent [stroke], #svgcontent [fill], g.background>rect[fill]').each(function () {
    editorUsedColors.push(hasColor(this, 'stroke'));
    editorUsedColors.push(hasColor(this, 'fill'));
  });

  return _.compact(_.uniq(editorUsedColors));
}

function initEditor () {
  const isPortrait = false;// (window.innerHeight > window.innerWidth);
  const $menu = $('#content, .menu');

  isPortrait
    ? $menu.removeClass('landscape') && $menu.addClass('portrait')
    : $menu.removeClass('portrait') && $menu.addClass('landscape');

  initScroll();

  const workarea = $(curConfig.workarea);
  const wOrig = parseFloat(workarea.width());
  const hOrig = parseFloat(workarea.height());
  const cnvp = $(curConfig.canvasPanel);

  cnvp.css('width', wOrig);
  cnvp.css('height', hOrig);
  cnvp.css('pointer-events', 'none');
}

function getOpacity (selected) {
  selected = selected || editor.canvas.getSelectedElems();

  if (!selected || !selected.length) return 1;

  return selected[0]?.getAttribute('opacity')
    ? selected[0].getAttribute('opacity')
    : 1;
}

function getStrokeWidth (selected) {
  selected = selected || editor.canvas.getSelectedElems();

  return getElementStrokeWidth(selected[0]);
}

function getElementStrokeWidth (elem) {
  if (!elem) return 0;

  let retval = 0;

  if ($(elem).hasClass('textarea')) {
    const textarea = new INKIVE.Text.Textarea().setDOM(elem);
    retval = textarea.text.stroke_width
      ? textarea.text.stroke_width
      : textarea.text.stroke === 'none'
        ? 0
        : 1;
  } else {
    const children = elem.childNodes;
    const nodes = (elem && elem.tagName !== 'g')
      ? [elem].concat(children)
      : children;

    for (let i = 0, len = nodes.length; i < len; i++) {
      if (nodes[i].tagName === 'g') {
        retval = getElementStrokeWidth(nodes[i]);
      } else if ($.inArray(nodes[i].tagName, ['path', 'line', 'polygon', 'rect', 'circle', 'ellipse']) >= 0) {
        retval = nodes[i].getAttribute('stroke-width')
          ? nodes[i].getAttribute('stroke-width')
          : nodes[i].getAttribute('stroke')
            ? 1
            : 0;
        break;
      }
    }
  }

  return (!retval || retval === 'none' || isNaN(retval))
    ? 0
    : Math.round(retval * 10) / 10;
}
